<template>
  <div class="flatpickr input-group">
    <input type="text" placeholder="Seleccione una fecha" ref="datepicker" class="form-control datepicker" data-input> <!-- input is mandatory -->
    <a class="input-group-addon" data-toggle>
        <i class="fa fa-calendar"></i>
    </a>
    <a class="input-group-addon" data-clear @click="onClickClear">
      <i class="fa fa-close"></i>
    </a>
  </div>
</template>
<script>
  import 'flatpickr/dist/flatpickr.css'
  import 'flatpickr/dist/themes/material_green.css'
  import './../../assets/css/custom.css'
  import flatpickr from 'flatpickr'
  import Spanish from 'flatpickr/dist/l10n/es.js'
  flatpickr.localize(Spanish.es)
  export default {
    props: {
      fechaInicial: {
        type: Date,
        default: () => null
      },
      maxDate: {
        type: Date,
        default: () => null
      },
      minDate: {
        type: Date,
        default: () => null
      },
      defaultDate: {
        type: Date,
        default: () => null
      },
      value: {
        type: Date,
        default: () => null
      }
    },
    data () {
      return {
        flatpickr: null
      }
    },
    methods: {
      onClickClear () {
        this.flatpickr.clear()
        this.$emit('clear')
      }
    },
    mounted () {
      const me = this
      me.flatpickr = flatpickr(me.$refs.datepicker, {
        dateFormat: 'd/m/Y',
        defaultDate: me.defaultDate,
        maxDate: this.maxDate || null,
        minDate: this.minDate || null,
        onChange: (e, i) => {
          // this.$emit('change-date', e)
          this.$emit('input', e[0])
        }
      })
    },
    watch: {
      defaultDate (newVal, oldVal) {
        this.flatpickr.setDate(newVal)
        this.$emit('input', newVal)
      }
    }
  }
</script>
<style scoped>
  form-control[disabled], .form-control[readonly], fieldset[disabled] .form-control {
    background-color: #fff;
    opacity: 1;
  }
</style>



// WEBPACK FOOTER //
// DatePicker.vue?4c96a3c4